<span
  class="mbs-status-ico"
  [ngClass]="iconClasses$ | async"></span>

@if (showStatusText$ | async) {
  <span
    #ngContentWrapperRef
    class="mbs-status-text"
    [ngClass]="textClasses$ | async">
    <ng-content />
  </span>
}
